var _defs, _circle, _path, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconStudyVirtualClassroom2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.846,
    cy: 13.443,
    r: 2.064
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.15 17.085a3.1 3.1 0 0 0-4.4 2.808"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 20.154,
    cy: 13.443,
    r: 2.064
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.85 17.085a3.1 3.1 0 0 1 4.4 2.808M15.549 5.812v3.117l-3.562 1.088-3.563-1.088V5.812"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m19.112 4.476-7.125-2.672-7.125 2.672 7.125 2.672 7.125-2.672zm-14.25 0v3.562m3.762.952v1.468a3.311 3.311 0 1 0 6.621 0V9.022M6.148 22.2a5.839 5.839 0 1 1 11.678 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m9.001 17.178 2.986 3.323 2.986-3.323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconStudyVirtualClassroom2);
export default __webpack_public_path__ + "static/media/streamline-icon-study-virtual-classroom-2.6b5b9b11.svg";
export { ForwardRef as ReactComponent };